import { req } from '../../@api/request';

export default class SignUpSerivce {
  static signUp = async (data: any) => {
    const result = await req.post('/users/sign/up', data);
    return result.data;
  };

  static CheckId = async (data: any) => {
    const result = await req.post(`/users/check/id`, data);
    return result.data;
  };

  static SendSms = async (data: any) => {
    const result = await req.post(`/users/auth/otp/send`, data);
    return result.data;
  };

  static CheckCode = async (data: any) => {
    const result = await req.post(`/users/auth/otp/verify`, data);
    return result.data;
  };

  static findId = async (data: any) => {
    const result = await req.post(`/users/find/id`, data);
    return result.data;
  };

  static findPassword = async (data: any) => {
    const result = await req.post(`/users/find/password`, data);
    return result.data;
  };

  static CheckRecommendCode = async (code: string) => {
    const result = await req.get(`/users/check/${code}`);
    return result.data;
  };
}
